import { render, staticRenderFns } from "./ListAlbumsChat.vue?vue&type=template&id=57e75e68&scoped=true&lang=html&"
import script from "./ListAlbumsChat.vue?vue&type=script&lang=js&"
export * from "./ListAlbumsChat.vue?vue&type=script&lang=js&"
import style0 from "./ListAlbumsChat.vue?vue&type=style&index=0&id=57e75e68&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e75e68",
  null
  
)

export default component.exports